import { useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { ShoppingBag, FlaskConical, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";

const navClass = ({ isActive }) =>
  `font-mono text-[11px] tracking-[0.25em] transition-colors ${
    isActive ? "text-[#00ff72]" : "text-[#A3A3A3] hover:text-[#F9F6F0]"
  }`;

export default function Header() {
  const { count, setCartOpen } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const goPepDaddy = () => {
    setMenuOpen(false);
    const scroll = () => {
      const el = document.getElementById("pep-daddy");
      if (!el) return;
      if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -70, duration: 1.4 });
      } else {
        el.scrollIntoView({ behavior: "smooth" });
      }
    };
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(scroll, 500);
    } else {
      scroll();
    }
    setTimeout(scroll, 1600);
  };

  return (
    <header
      data-testid="site-header"
      className="fixed left-0 right-0 top-0 z-40 border-b border-white/10 bg-black/60 backdrop-blur-xl saturate-150"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
          <FlaskConical className="h-5 w-5 text-[#00ff72]" />
          <span className="font-mono text-xs tracking-[0.25em] text-[#F9F6F0] sm:text-sm">
            SFH BIOHEALTH <span className="text-[#00ff72]">&amp; WELLNESS</span>
          </span>
        </Link>
        <nav className="hidden items-center gap-8 lg:flex">
          <NavLink to="/" end data-testid="nav-home-link" className={navClass}>
            HOME
          </NavLink>
          <NavLink to="/products" data-testid="nav-catalog-link" className={navClass}>
            CATALOG
          </NavLink>
          <NavLink to="/pricing" data-testid="nav-pricing-link" className={navClass}>
            PRICE LIST
          </NavLink>
          <NavLink to="/products?category=Ketones" data-testid="nav-ketones-link" className={navClass}>
            KETONES
          </NavLink>
          <NavLink to="/products?category=Merch" data-testid="nav-merch-link" className={navClass}>
            MERCH
          </NavLink>
          <button
            data-testid="nav-pepdaddy-link"
            onClick={goPepDaddy}
            className="font-mono text-[11px] tracking-[0.25em] text-[#A3A3A3] transition-colors hover:text-[#00ff72]"
          >
            PEP DADDY
          </button>
        </nav>
        <div className="flex items-center gap-3">
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setMenuOpen((o) => !o)}
            className="p-1 text-[#F9F6F0] transition-colors hover:text-[#00ff72] lg:hidden"
            aria-label="Menu"
          >
            {menuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
          <button
            data-testid="cart-toggle-btn"
          onClick={() => setCartOpen(true)}
          className="relative flex items-center gap-2 border border-white/20 px-4 py-2 font-mono text-[11px] tracking-[0.2em] text-[#F9F6F0] transition-colors hover:border-[#00ff72] hover:text-[#00ff72]"
        >
          <ShoppingBag className="h-4 w-4" />
          CART
          {count > 0 && (
            <span
              data-testid="cart-count-badge"
              className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center bg-[#00ff72] font-mono text-[10px] text-black"
            >
              {count}
            </span>
          )}
          </button>
        </div>
      </div>
      {menuOpen && (
        <nav data-testid="mobile-menu" className="border-t border-white/10 bg-black/95 px-6 py-2 backdrop-blur-xl lg:hidden">
          {[
            { to: "/", label: "HOME", testId: "mobile-nav-home" },
            { to: "/products", label: "CATALOG", testId: "mobile-nav-catalog" },
            { to: "/pricing", label: "PRICE LIST", testId: "mobile-nav-pricing" },
            { to: "/products?category=Ketones", label: "KETONES", testId: "mobile-nav-ketones" },
            { to: "/products?category=Merch", label: "MERCH", testId: "mobile-nav-merch" },
          ].map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              onClick={() => setMenuOpen(false)}
              className="block border-b border-white/5 py-4 font-mono text-xs tracking-[0.25em] text-[#A3A3A3] transition-colors last:border-0 hover:text-[#00ff72]"
            >
              {l.label}
            </Link>
          ))}
          <button
            data-testid="mobile-nav-pepdaddy"
            onClick={goPepDaddy}
            className="block w-full border-b border-white/5 py-4 text-left font-mono text-xs tracking-[0.25em] text-[#A3A3A3] transition-colors last:border-0 hover:text-[#00ff72]"
          >
            PEP DADDY FOR PUPS
          </button>
        </nav>
      )}
    </header>
  );
}
